import React from 'react';
import './EmptyState.css';

class EmptyState extends React.Component {
  render() {
    return (
        <div className="empty-state-container">
            <div className="row">
                <div className="vertical-separator-30px"></div>

                <div className="col-md-6 col-md-offset-3 text-center">
                    <p className="empty-state title">{this.props.title}</p>
                </div>
                
                <div className="vertical-separator-30px"></div>
                <div className="vertical-separator-30px"></div>

                <div className="col-md-4 col-md-offset-4 text-center">
                    <span>
                        <i className={`${this.props.illustration} empty-state illustration`}></i>
                    </span>
                </div>

                <div className="vertical-separator-30px"></div>

            </div> 
        </div>
    )
  }
}

export default EmptyState;



// WEBPACK FOOTER //
// ./src/views/Components/Presentation/EmptyState/EmptyState.js